import { render } from "./TradeDetails.vue?vue&type=template&id=f4bd7ddc&scoped=true"
import script from "./TradeDetails.vue?vue&type=script&lang=js"
export * from "./TradeDetails.vue?vue&type=script&lang=js"

import "./TradeDetails.vue?vue&type=style&index=0&id=f4bd7ddc&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4bd7ddc"]])

export default __exports__